export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Forms.vue?vue&type=template&id=427740dd&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Styles/Forms.vue?vue&type=template&id=427740dd&scoped=true&
// module id = null
// module chunks = 